import { DialogContent, Grid, Stack } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  getRecruiterSMTPAccounts,
  inviteShareCandidateUsersByInformation,
  ISMTPAccountsResponse,
  sendInformationReq,
} from 'wisestep-api';
import {
  WsButton,
  WsColors,
  WsDialog,
  WsDialogSize,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { useSurveyLogoUrl } from '../../../components/SurveyBuilder/SurveyCommonMethods';
import { failed, success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

const useStyles = makeStyles({
  customButton: {
    textTransform: 'none',
    maxWidth: '150px',
    whiteSpace: 'nowrap',
    lineHeight: '1.2',
  },
});
interface IShareCandidateByJob {
  interactionId?: string;
  onClose: () => void;
  reset: () => void;
  jobTitle?: string;
  name?: string;
  email?: string;
  jobCode?: string;
  jobLocation?: any;
  jobId?: string;
  informationTemplateId?: string;
  infoReqResponsesId?: string;
  onSentRequest: () => void;
  id?: string;
  isMapping?: boolean;
}
const ShareCandidateByJob = ({
  interactionId,
  onClose,
  jobTitle,
  jobCode,
  email,
  name,
  jobLocation,
  jobId,
  informationTemplateId,
  infoReqResponsesId,
  onSentRequest,
  id,
  isMapping,
}: IShareCandidateByJob) => {
  const [defaultSmtpEmail, setDefaultSmtpEmail] = useState<string | undefined>('');
  const [preferredProviderId, setPreferredProviderId] = useState<string>('');
  const setNotification = useNotificationStore((state) => state.setNotification);
  const methods = useForm();
  const classes = useStyles();
  const fileUrlValue = useSurveyLogoUrl();

  useEffect(() => {
    (async () => {
      const smtpResponse = await getRecruiterSMTPAccounts();
      if (smtpResponse && smtpResponse.data) {
        const allEmails: ISMTPAccountsResponse[] = smtpResponse.data;
        let defaultEmail = allEmails.find((email) => email.isDefault);
        if (!defaultEmail) {
          defaultEmail = allEmails[0];
        }
        setDefaultSmtpEmail(defaultEmail.fromEmail);
        setPreferredProviderId(defaultEmail.id);
      }
    })();
  }, []);

  const fullUrl = `${window.location.href}&corphiringTemplate=informationrequestTemplate`;

  const onSubmit = async (data) => {
    try {
      if (data && jobCode) {
        await inviteShareCandidateUsersByInformation({
          subject: `Information Required for ${jobTitle} || ${name}`,
          body: data.description,
          interactionId: interactionId,
          jobId: jobId,
          sharedCandidateName: name,
          sharedJobTitle: jobTitle,
          sharedJobLocation: jobLocation,
          sharedCandidateEmail: email,
          sharedJobCode: jobCode,
          informationTemplateId: informationTemplateId,
          isRTR: false,
          recruiterEmail: defaultSmtpEmail ?? '',
          logoUrl: fileUrlValue ?? '',
          isMapping: isMapping,
          otherInfo: [{ candidateProfileLink: fullUrl }],
          preferredProviderId: preferredProviderId,
        });
        await sendInformationReq({
          id: infoReqResponsesId as string,
          mappingInteractionId: id as string,
        });
        setNotification(success(' Information request sent to candidate!'));
        onSentRequest();
      }
    } catch (e) {
      setNotification(failed('An error occurred'));
    }
  };

  return (
    <>
      <WsDialog size={WsDialogSize.SMALL} openDialog={true} onClose={onClose}>
        <Grid container sx={{ backgroundColor: WsColors.TertiaryShades200, pb: 1.3 }}>
          <Grid item xs={8}>
            <Stack direction="row" sx={{ mt: 1, ml: 3 }} spacing={1}>
              <WsTypography display="inline" variant={WsTypoVariants.SUB_TITLE}>
                Share Candidate
              </WsTypography>
            </Stack>
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DialogContent>
            <FormProvider {...methods}>
              <Grid container>
                <Grid item xs={12}>
                  <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.PRIMARY}>
                    {`Candidate Name  - ${name}`}
                  </WsTypography>
                </Grid>
                <Grid item xs={12} style={{ marginTop: '10px', marginBottom: '10px' }}>
                  <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.PRIMARY}>
                    {`Candidate Email ID - ${email}`}
                  </WsTypography>
                </Grid>
                <Grid container>
                  <Grid container style={{ marginTop: '10px' }}>
                    <Grid item xs={8}></Grid>
                    <Grid item xs={2}>
                      <WsButton onClick={onClose} variant="outlined">
                        Close
                      </WsButton>
                    </Grid>
                    <Grid item xs={2}>
                      <WsButton
                        type="submit"
                        size="small"
                        variant="contained"
                        className={classes.customButton}
                      >
                        Send Request
                      </WsButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </FormProvider>
          </DialogContent>
        </form>
      </WsDialog>
    </>
  );
};

export default ShareCandidateByJob;
